<template>
  <modal v-if="visible"
         :modal-key="'home-screen-shortcut'"
         :class-style="'modal modal--welcomeback modal--zero-balance modal_phone_screen'"
         :header-style="'modal__header'"
         :body-style="'modal__body'"
         :footer-style="'modal__footer footer_buttons'"
         @close="close()">
<!--    <div class="modal__content">-->
      <template slot="header">
        <h1>{{ getTranslations.home_shortcut_text1 }}</h1>
        <img class="pinicon" src="static/images/mobile_new.png" alt="">
      </template>
      <template slot="body">
        <p v-if="iOSdevice()">{{ getTranslations.home_shortcut_text2_ios }} </p>
        <p v-else>{{ getTranslations.home_shortcut_text2_android }}</p>
      </template>
      <template slot="footer">
        <span v-if="iOSdevice()">
          <button @click="installiOSdevice()" class="btn2 btn2--small btn2--std">{{ getTranslations.home_shortcut_button_ok }}</button>
        </span>
        <span v-else>
          <button @click="$emit('cancel')" class="btn2  btn2--outline btn2--small">{{ getTranslations.home_shortcut_button_no }}</button>
          <button @click="install()" class="btn2 btn2--small btn2--std">{{ getTranslations.home_shortcut_button_yes }}</button>
        </span>
      </template>
<!--    </div>-->
  </modal>
</template>

<script>
import Modal from '@/components/home/modals/shared/GenericModal';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'home-screen-shortcut',
  components: {
    Modal,
  },
  data() {
    return {
      showInstallButton: false,
      deferredPrompt: '',
      visible: true,
    };
  },
  beforeDestroy() {
    this.removeManifestLink();
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
      'clearInstallPromptEvent',
      'storeHomeScreenModalDisable',
    ]),
    ...mapActions('common', [
      'phoneShortcutInstalled',
    ]),
    iOSdevice() {
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        console.log('User is accessing from an iOS device');
        return true;
      }
      return false;
    },
    installiOSdevice() {
      this.phoneShortcutInstalled({ shortcutCreated: true }).then(() => {
        localStorage.setItem('homeScreenModalApplied', 'true');
        this.visible = false;
        this.$emit('ok');
      });
    },
    close() {
      sessionStorage.setItem('homeScreenModalDenied', 'true');
      this.storeHomeScreenModalDisable(true);
      this.$emit('close');
    },
    closeModal() {
      this.visible = false;
      this.$emit('ok');
      // window.removeEventListener('beforeinstallprompt', null);
    },
    beforeInstallPromptHandler(event) {
      // Prevent the default browser behavior to suppress the installation prompt
      event.preventDefault();
      // Store the event to prompt the user later
      console.log('EVENT', event);
      this.deferredPrompt = event;
    },
    removeManifestLink() {
      const manifestLink = document.querySelector('link[rel="manifest"]');
      if (manifestLink) {
        document.head.removeChild(manifestLink);
        this.clearInstallPromptEvent();
      }
    },
    install() {
      this.deferredPrompt = this.getInstallPromptEvent;
      if (this.deferredPrompt) {
        // Show the installation prompt
        this.deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the install prompt.');
            this.phoneShortcutInstalled({ shortcutCreated: true }).then(() => {
              localStorage.setItem('homeScreenModalApplied', 'true');
            });
          } else {
            console.log('User dismissed the install prompt.');
            sessionStorage.setItem('homeScreenModalDenied', 'true');
          }
          // Clear the deferredPrompt variable to avoid multiple prompts
          // this.deferredPrompt = null;
        });
      }
      // Close the modal after the user responds to the prompt
      this.closeModal();
    },
  },
  computed: {
    ...mapState('common', [
      'installPromptEvent',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('common', [
      'getInstallPromptEvent',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/HomeScreenShortcut.vue